import experiment from './experiment';

export default experiment;
